import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import HubspotForm from 'react-hubspot-form';
import FocusLock from 'react-focus-lock';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

import Button from '../../../Core/Button';
import Portal from '../../../Core/Portal';

import { Overlay, Modal, CloseIcon } from './styles';

function Hubspot({ uuid, data, className }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    const body = document.querySelector('body');
    if (open) body.classList.add('js-no-scroll');
    else body.classList.remove('js-no-scroll');
  }, [open]);

  const onOverlayClick = (e) => {
    if (e.target.id === 'hubspot-overlay') setOpen(false);
  };

  return (
    <>
      <Button className={className} onClick={() => setOpen(true)}>
        {data}
      </Button>
      <Portal>
        {open && (
          <Overlay id="hubspot-overlay" onClick={onOverlayClick}>
            <FocusLock>
              <Modal>
                <button
                  className="close-btn"
                  aria-label="close"
                  type="submit"
                  onClick={() => setOpen(false)}
                >
                  <CloseIcon icon={faTimes} />
                </button>
                <HubspotForm
                  portalId="2548601"
                  formId={uuid}
                  onSubmit={() =>
                    (window.dataLayer || {}).push({
                      event: 'sl-admin-submitted',
                    })
                  }
                  loading={<div>Loading...</div>}
                />
              </Modal>
            </FocusLock>
          </Overlay>
        )}
      </Portal>
    </>
  );
}

Hubspot.propTypes = {
  data: PropTypes.string,
  uuid: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Hubspot.defaultProps = {
  data: "See your building's users",
  className: 'solid-on-light-bg',
};

export default Hubspot;
